import { useLocator } from '@/store/locator.js'

// Resolves the current API base URL from the locator store for every request.
export function setApiBaseUrl(config) {
  config.baseURL = useLocator().getApiUrl

  return config
}
